import {FormFields} from '../checkout';
import {type PeachPayCheckoutData} from '../types';
import {AbstractStripePayment, type ConfirmResult, type TokenResult} from './abstract/class-abstract-stripe-payment';
import {billingDetails} from './stripe';

declare const peachpay_checkout_data: PeachPayCheckoutData;

class StripeSofortPayment extends AbstractStripePayment {
	public gatewayId() {
		return 'peachpay_stripe_sofort';
	}

	public async tokenize(): Promise<TokenResult> {
		const sofort_details = {
			sofort: {
				country: FormFields.billing.country.get(),
			},
			billing_details: billingDetails(),
		};

		if (peachpay_checkout_data.page.is_order_pay && peachpay_checkout_data.order_pay_details) {
			sofort_details.billing_details.name = peachpay_checkout_data.order_pay_details.billing_first_name + ' ' + peachpay_checkout_data.order_pay_details.billing_last_name;
			sofort_details.billing_details.email = peachpay_checkout_data.order_pay_details.billing_email;
			sofort_details.sofort.country = peachpay_checkout_data.order_pay_details.billing_country ?? '';
		}

		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			type: 'sofort',
			...sofort_details,
		});

		if (error) {
			const message = error.message ?? 'Failed to tokenize payment method.';

			return [null, {
				paymentStatus: 'creationfailed',
				note: message,
			}];
		}

		if (!paymentMethod?.id) {
			return [null, {
				paymentStatus: 'creationfailed',
				note: 'Failed to tokenize payment method.',
			}];
		}

		return [paymentMethod.id, {}];
	}

	public async confirm(clientSecret: string, intermediateURL?: string | undefined): Promise<ConfirmResult> {
		const {paymentIntent, error} = await this.stripe.confirmSofortPayment(clientSecret, {return_url: intermediateURL});

		if (error) {
			const message = error.message ?? 'Failed to confirm payment.';
			return [null, {
				note: message,
			}];
		}

		if (paymentIntent) {
			return ['success', {}];
		}

		return [null, {}];
	}
}

export {
	StripeSofortPayment,
};
